import { getComposeStore } from 'owa-calendar-compose-store-manager';
import type { ClientItemId } from 'owa-client-ids';

export default function getEventClientItemId(): ClientItemId {
    const { event } = getComposeStore();
    return event.ItemId;
}
